import { EntityBrief } from '../tamalelibs/models/entity-brief.model';

export class SavedScreen {
    accessList: string[] = [];
    author: EntityBrief;
    configuration?: any;
    deletable: boolean;
    description: string;
    editable: boolean;
    id: string;
    isPublic: boolean;
    name: string;
    type: any;
    visible: boolean;
}

export class SavedDashboard {
    accessList: string[] = [];
    author: EntityBrief;
    configuration: {
        focus: ScreenFocus,
        widgets: any[],
    };
    deletable: boolean;
    description: string;
    editable: boolean;
    id: string;
    isPublic: boolean;
    name: string;
    type: 'dashboard';
    visible: boolean;
}

export class ScreenFocus {
    type: ScreenFocusType;
    entityId?: string; // available for SPECIFIC_ENTITY
    entityTypes?: string[]; // available for ENABLE_FOCUS_CONTROL
    relationshipTypes?: string[]; // avialble for SPECIFIC_ENTITY, CURRENT_USER
    includeSpecificEntityItself?: false;
}

export enum ScreenFocusType {
    ENABLE_FOCUS_CONTROL = 0,
    ALL = 1,
    SPECIFIC_ENTITY = 2,
    CURRENT_USER = 3
}
